// host page for the list of all Experimental Data
// fetch the information from the server

import React from 'react';
import { Link } from 'react-router-dom';
import methods from '../images/challenge/metrics001.png';

class Metrics extends React.Component {
    constructor(props){
        super(props)
    }

    render(){
        return (
            <div>
                <h1>Super-resolution microscopy metrics</h1>
                <div style={{height:"20px"}}></div>
                <p className="lead">When working with super-resolution datasets, there is a general need to assess the quality and fidelity of the results.<br></br>
                The assessment is made through the application of various signal processing methods.<br></br>
                Here presents a list of such methods, which we divided into two categories: </p>
                <ul>
                    <li><p className="lead"> <strong>Ground-truth based </strong> methods are essentially exclusive to localization microscopy when working with simulated dataset.
                        The knowledge of the emitters positiion allows to quantify the fidelity and robustness of a localization algorithm. The most common <strong>Ground-truth based</strong> (also used in the 2016 SMLM Challenge) are presented below.</p>
                    </li>
                    <li><p className="lead"><strong>Image based</strong> methods are much more general as they can be appied to any type of images. As a drawback, they cannot estimate the fidelity of a super-resolution image but aim at estimate more general features of microscopy images such as resolution or Signal-to-Noise Ratio by making assumptions about the image formation process.
                    A selection of <strong>Image based</strong> methods are presented in dedicated subpages (build links from websiteStruct.json).</p>
                    </li>
                    <div style={{height:"10px"}}></div>
                </ul>
                {
                //<p className="lead"> If you whish to see another <strong>Ground-truth based </strong> or <strong>Image based</strong> method here, please contact us using <Link to="/Methods/Form">this form</Link>.</p>
                }
                
                <div style={{height:"20px"}}></div>
                <h2><strong>Ground-truth based method (localization microscopy)</strong></h2>
                <div style={{height:"20px"}}></div>
                <h3>Jaccard Index, Recall, Precision, RMSE and MAD</h3>
                    <p> All theses methods were used in the 2016 SMLM Challenge and requires the pairing of each localization with the corresponding ground-truth (provided it exists).
                        The pairing information can be used to compute statistics related to the detection efficiency or quantify the average accuracy of the localizations.</p>
                    <div style={{display:"flex",justifyContent:"center"}}>
                        <img src={methods} width="1100px"></img>
                    </div>
                <div style={{height:"20px"}}></div>

                {/* 
                <h3>Optimal transport</h3>
                    Short description of the idea? Link to paper? Figures?.

                <div style={{height:"20px"}}></div>
                <h3>Any other algorithm worth mentioning</h3>
                    ??

                
                <ul>
                    <li>
                        One page dedicated to ground-truth based metrics (mae, jaccard, optimal transport, etc..)
                    </li>
                    <li>
                        One page per image based metrics
                    </li>
                    <ul>
                        <li>
                            Decorr: illustration, ref to papers and link to github
                        </li>
                        <li>
                            FRC: illustration, ref to papers and link to biop plugin
                        </li>
                        <li>
                            Squirrel, local FRC and image blurring...
                        </li>
                        <li>
                            SNR metrics 
                        </li>
                    </ul>
                </ul>
                */}
            </div>
        )
    }

}

export default Metrics;
